import React from "react";

export default function SectionBarComparison({ sections = [] }) {
  return (
    <div>
      {sections.map((section) => {
        const orgPct = Math.min(100, Math.max(0, section.orgScore || 0));
        const benchPct = Math.min(100, Math.max(0, section.benchmarkScore || 0));
        return (
          <div key={section.key} className="section-bar-row">
            <div className="section-bar-label">
              <span>{section.label}</span>
              <span>
                You {section.orgScore?.toFixed(1)} · Bench {section.benchmarkScore?.toFixed(1)}
                <span style={{ marginLeft: 8, color: section.gap >= 0 ? "#059669" : "#dc2626" }}>
                  ({section.gap >= 0 ? "+" : ""}
                  {section.gap?.toFixed(1)})
                </span>
              </span>
            </div>
            <div className="section-bar-track">
              <div
                className="section-bar-org"
                style={{ width: `${orgPct}%`, background: section.color }}
              />
              <div className="section-bar-bench" style={{ left: `${benchPct}%` }} title="Benchmark" />
            </div>
          </div>
        );
      })}
      <div className="benchmark-legend">
        <span>
          <span className="legend-swatch" style={{ background: "#02b880" }} /> Your organization
        </span>
        <span>
          <span className="legend-marker" /> Benchmark reference
        </span>
      </div>
    </div>
  );
}
